import { FadeInImage } from './FadeinImage';

class PageNews {
    constructor() {
        this.filter = document.querySelector('.js-filter');
        this.offsetInput = this.filter.querySelector('.js-input-offset');
        this.newsContainer = document.querySelector('.js-news');
        this.ajaxUrl = this.filter.getAttribute('data-ajax-url');
        this.trigger = document.querySelector('.js-news-more');

        if (this.filter) {
            this.bindFilter();
        }

        if (this.trigger && this.filter) {
            this.bindBtnMore();
        }
    }


    /**
     * Фильтр
     */
    bindFilter() {
        this.filter.querySelectorAll('select, input').forEach(input => {
            input.addEventListener('change', () => {
                this.filter.submit();
            });
        });
    }


    /**
     * Подгрузка новостей
     */
    bindBtnMore() {
        this.trigger.addEventListener('click', () => {
            this.loadMore();
        });
    }


    loadMore() {
        this.offsetInput.value = this.newsContainer.querySelectorAll('.news-item').length;
        this.offsetInput.disabled = false;

        this.trigger.classList.add('_is-active');

        /**
         * Грузим
         */
        $.ajax({
            url: this.ajaxUrl,
            data: $(this.filter).serialize(),
            type: this.filter.getAttribute('method') || 'GET',
            cache: false,
            success: (response) => {
                if (response) {
                    /**
                     * Вытаскиваем разметку из ответа
                     */
                    const tmp = document.createElement('div');
                    tmp.innerHTML = response;
                    const inner = tmp.querySelector('[data-html]');

                    if (!inner) return;

                    /**
                     * Добавляем карточки в каталог
                     */
                    this.newsContainer.insertAdjacentHTML('beforeend', inner.innerHTML);
                    this.updateLazyLoad();

                    /**
                     * Если есть маркер, что это последние элементы,
                     * отключаем триггер
                     */
                    if (inner.getAttribute('data-last') === 'true') {
                        this.trigger.style.display = 'none';
                    }
                } else {
                    console.log('Ошибка получения каталога');
                }


                this.trigger.classList.remove('_is-active');
                this.offsetInput.disabled = true;
            },
            error: () => {
                console.log('Ошибка на сервере');
                this.trigger.classList.remove('_is-active');
                this.offsetInput.disabled = true;
            }
        });
    }


    /**
     * Обновляем lazy-load загрузку для вновь добавленных новостей
     */
    updateLazyLoad() {
        this.newsContainer.querySelectorAll('[data-fadein]').forEach(el => {
            new FadeInImage(el);
        });
    }
}

if (document.querySelector('html.page-news')) {
    new PageNews();
}



// WEBPACK FOOTER //
// ./_src/js/PageNews.js